// src/ConsumerApp/Screens/ProductsList/components/BulkRfqCategoryBanner.js

import React from 'react';
import WhatsappLogo from '../../../../assets/icons/WhatsApp.svg';

const BUSINESS_WHATSAPP_NUMBER = '918639065454';

export default function BulkRfqCategoryBanner({ categoryName }) {
  const isCement = categoryName?.toLowerCase().includes('cement');

  const handleOpenWhatsAppRFQ = () => {
    const materialReq = isCement ? 'Cement (50 bags and above)' : categoryName || 'Materials';
    const message = encodeURIComponent(`Hi, I have a bulk requirement for ${materialReq}. Please provide a quote.`);
    window.open(`https://wa.me/${BUSINESS_WHATSAPP_NUMBER}?text=${message}`, '_blank');
  };

  return (
    <div className="bb-bulk-banner-wrapper">
      <style>{`
        .bb-bulk-banner-wrapper {
          width: 100%;
          display: flex;
          justify-content: center;
          margin: 16px 0 20px 0;
        }

        .bb-bulk-banner-card {
          background-color: #ECFDF5;
          border-radius: 14px;
          border: 1px solid #A7F3D0;
          padding: 14px 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          max-width: 580px; /* Constrained on wide screens */
          box-sizing: border-box;
          gap: 16px;
          box-shadow: 0 2px 8px rgba(16, 185, 129, 0.08);
          transition: transform 0.15s ease, box-shadow 0.15s ease;
        }

        .bb-bulk-banner-card:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 14px rgba(16, 185, 129, 0.14);
        }

        .bb-bulk-left-group {
          display: flex;
          align-items: center;
          gap: 12px;
          min-width: 0;
        }

        .bb-bulk-icon-circle {
          width: 38px;
          height: 38px;
          border-radius: 19px;
          background-color: #25D366;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          box-shadow: 0 2px 6px rgba(37, 211, 102, 0.3);
        }

        .bb-bulk-text-cluster {
          display: flex;
          flex-direction: column;
          min-width: 0;
        }

        .bb-bulk-title {
          margin: 0;
          font-size: 14px;
          font-weight: 800;
          color: #064E3B;
          letter-spacing: -0.2px;
        }

        .bb-bulk-subtitle {
          font-size: 12px;
          color: #047857;
          margin-top: 1px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .bb-bulk-action-btn {
          background-color: #E9001E;
          color: #FFFFFF;
          border: none;
          padding: 9px 16px;
          border-radius: 8px;
          font-size: 12px;
          font-weight: 800;
          cursor: pointer;
          flex-shrink: 0;
          white-space: nowrap;
          box-shadow: 0 2px 6px rgba(233, 0, 30, 0.25);
          transition: background-color 0.15s ease;
        }

        .bb-bulk-action-btn:hover {
          background-color: #C7061F;
        }

        @media (max-width: 540px) {
          .bb-bulk-banner-card {
            flex-direction: column;
            align-items: stretch;
            gap: 12px;
            padding: 12px 14px;
          }

          .bb-bulk-action-btn {
            width: 100%;
            text-align: center;
            padding: 10px;
          }
        }
      `}</style>

      <div className="bb-bulk-banner-card">
        <div className="bb-bulk-left-group">
          <div className="bb-bulk-icon-circle">
            <img src={WhatsappLogo} alt="WhatsApp" style={{ width: 20, height: 20 }} />
          </div>
          <div className="bb-bulk-text-cluster">
            <h4 className="bb-bulk-title">Got bulk requirement?</h4>
            <span className="bb-bulk-subtitle">Share requirement directly on WhatsApp</span>
          </div>
        </div>

        <button type="button" className="bb-bulk-action-btn" onClick={handleOpenWhatsAppRFQ}>
          Request Quote
        </button>
      </div>
    </div>
  );
}